/** Goal shown to donors (need amount + fee already included in total goal). */
export function needDisplayGoal(need) {
  return Number(
    need?.totalGoalAmount ||
      Number(need?.goalAmount || 0) + Number(need?.processingFeeAmount || 0)
  );
}

export function resolvePlatformSupportAmount(choice, customValue) {
  if (!choice || choice === 'none') return 0;
  if (choice === 'custom') {
    const n = Number(customValue);
    return Number.isFinite(n) && n > 0 ? Math.round(n) : 0;
  }
  const preset = Number(choice);
  return Number.isFinite(preset) && preset > 0 ? preset : 0;
}

/** Checkout total: contribution + optional DonorTrack support (no per-donation processing fee). */
export function buildDonationCheckout({
  contribution,
  platformSupportChoice,
  platformSupportCustom
}) {
  const contributionAmount = Math.max(0, Number(contribution) || 0);
  const platformSupport = resolvePlatformSupportAmount(
    platformSupportChoice,
    platformSupportCustom
  );
  const total = Math.round((contributionAmount + platformSupport) * 100) / 100;

  return {
    contributionAmount,
    platformSupport,
    total
  };
}

export function needAmountRemaining(need) {
  if (!need) return 0;
  const goal = needDisplayGoal(need);
  const raised = Number(need.raisedAmount || 0);
  return Math.max(0, Math.round((goal - raised) * 100) / 100);
}
